// extracted by mini-css-extract-plugin
export default {"source_img":"source-img_source_img__ykS-q"};